import React from 'react';

import { Box, Text, HStack } from '@chakra-ui/react';

import { useColors } from './colors';

const TabNavigation = ({ activeTab, setActiveTab, tabs }) => {
  const { borderColor, textColor, headingColor } = useColors();

  return (
    <Box mb={6}>
      <HStack spacing={8} borderBottom="2px solid" borderColor={borderColor} overflowX="auto">
        {tabs.map((tab) => (
          <Box
            key={tab.id}
            position="relative"
            cursor="pointer"
            onClick={() => setActiveTab(tab.id)}
            flexShrink={0}
          >
            <Text
              fontSize="md"
              fontWeight={activeTab === tab.id ? 'semibold' : 'normal'}
              color={activeTab === tab.id ? headingColor : textColor}
              py={3}
              transition="all 0.2s"
              _hover={{ color: headingColor }}
            >
              {tab.label}
            </Text>
            {activeTab === tab.id && (
              <Box
                position="absolute"
                bottom="-2px"
                left="0"
                right="0"
                height="2px"
                bg="blue.500"
                borderRadius="1px"
              />
            )}
          </Box>
        ))}
      </HStack>
    </Box>
  );
};

export default TabNavigation;
